"use client";

//弹窗展示产品尺寸图
import React from "react";
import { filterByLensTotalWidth } from "@/src/utils/lens/productdetail";
import { FmIcon } from "@/ui-component";
import stl from "../styles/sizechart.module.scss";
import classnames from "classnames";
import SizeChartClient from "./SizeChartClient";
import variable from "@/src/styles/variables.module.scss";
import { useTranslation } from "@/src/i18n/client";
interface IProps {
    productDetail: any;
    isShowSizeGuide: boolean;
    language: string;
}

const SizeChart: React.FC<IProps> = (props) => {
    const { productDetail, language } = props;

    const width = filterByLensTotalWidth(productDetail.dimensions_total_width);
    const { t } = useTranslation(["productDetail"]);
    return (
        <SizeChartClient {...props}>
            {props.isShowSizeGuide ? (
                <FmIcon icon={"icon--FAQ"} className={stl["size-guide"]} />
            ) : (
                <div
                    className={classnames(
                        "default_layout",
                        stl["size-guide-container"],
                    )}
                >
                    <div className={stl["product-width-icon"]}>{width}</div>
                    <span style={{ color: variable.main }}>
                        {t("productDetail:SizeGuide")}
                    </span>
                </div>
            )}
        </SizeChartClient>
    );
};

export default SizeChart;
